import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { FormArray,AbstractControl, FormControl, FormBuilder, Validators, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ValidationService } from '../../../app/validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import { UploadService } from '../../../app/shared/upload.service';
import { Subscription } from 'rxjs-compat/Subscription';
import { HttpClientModule, HttpClient, HttpRequest, HttpResponse, HttpEventType } from '@angular/common/http';
import { debounce } from 'rxjs/operators';
import  moment from 'moment-timezone';
import { FileUploadModule } from 'ng2-file-upload';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-admin-profile',
  templateUrl: './admin-profile.component.html',
  styleUrls: ['./admin-profile.component.scss'],
  standalone:true,
  imports:[CommonModule,FormsModule,ReactiveFormsModule,FileUploadModule,MatButtonModule,NgxIntlTelInputModule]
})
export class AdminProfileComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL+'uploads/';
  public registerUserUrl = BaseUrlConstantsService.REGISTER_USERS;
  public managerListingUrl = BaseUrlConstantsService.MANAGER_LIST;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public editUserUrl = BaseUrlConstantsService.EDIT_USER_INFO;
  public updateLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public productListingUrl = BaseUrlConstantsService.PRODUCTLIST;
  public getClientProductsUrl = BaseUrlConstantsService.CLIENTS_PRODUCTS;
  public form: FormGroup;
  public uForm: FormGroup;
  public updateDataReq: any = false;
  public _imgUrl = "./assets/img-new/default_user.png";
  public _imageId = null;
  public countryNames: any;
  public countryname: any;
  public url: any;
  public selectedCountry: any;
  defaultFlgONphone:string;
  public industryType:any = [];
  public userId: any;
  public maxLength = 0;
  public id: any;
  public uploader: FileUploader;
  public showCancelBtn: boolean;
  public percentDone = 0;
  public uploadSuccess: boolean;
  public states: any = [];
  public _userRole: any;
  public uploadResponse = { status: '', message: '', filePath: '' };
  public fileName = '';
  licenceTypeArray:any = [];
  public timeZones: any = [];
  public company_full_name: string
  public today: Date;
  userRoll:string;
  public invoiceForm: FormGroup;
  public _companyLogo: any = "./assets/img-new/default_user.png";
  public companyUploader : FileUploader;
  public companyFileName: string;
  public productBoxList: any =[];
  public clientProducts: any;
  public productBoxListData: any =[];

  constructor(private http: HttpClient,
    public router: Router,
    private uploadService: UploadService,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    public dialog: MatDialog,

    private formBuilder: FormBuilder) {
      this.countryname = localStorage.getItem('country');
    switch(this.countryname){
      case 'Canada' :
        this.countryname= 'ca';
        break;
      case 'India':
        this.countryname = 'in';
        break;
      case 'United States':
        this.countryname = 'us';
        break;
    }
      this.company_full_name = localStorage.getItem('company_name');
      this.userRoll = localStorage.getItem('role');
      this.utcTime();
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.IMAGE_UPLOAD, itemAlias: 'photo' });
    this.companyUploader =new FileUploader({url: BaseUrlConstantsService.IMAGE_UPLOAD +'/logo', itemAlias: 'photo'});
  }


  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  gotoHome(){
    if(localStorage.getItem('role') === 'ADMIN'){
      this.router.navigate(['/admin-dashboard']);
    }else if(localStorage.getItem('role') === "CLIENT" || localStorage.getItem('role') === "USER"){
      this.router.navigate(['/device-reports']);
    }
    else if(localStorage.getItem('role') === "OEM"){
      this.router.navigate(['/OEM-Client']);
    }
      else{
      this.router.navigate(['/manager-client-list']);
    }

  }

  // onChangePhoneNo(nam) {

  // }

  ngOnInit() {

    this.timeZones = moment.tz.names();
    // this.invoiceForm = this.formBuilder.group({
    //   itemRows: this.formBuilder.array([this.initItemRows()])
    // });
    this.userId = localStorage.getItem('user_id');
    this.form = this.formBuilder.group({
      avatar: ['']
    });
    this.uForm = this.formBuilder.group({
      company_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      industry_type: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      full_name: new FormControl('',[Validators.required, this.noWhitespaceValidator]),
      email: new FormControl('', ValidationService.emailValidator),
      password: new FormControl('', ValidationService.passwordValidator),
      phone_number: new FormControl('', [Validators.required]),
      address_line1: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      address_line2: new FormControl(''),
      country_name_: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      state_name: new FormControl('', [Validators.required]),
      city_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      timezone: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      postcode: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      number_of_license: new FormControl(''),
      account_manager: new FormControl({ value: "", disabled: true }),
    });

    this.service.load().then(data => {
      this.countryNames = JSON.parse(JSON.stringify(data)).countries;
    });

    this.service.industryType().then(data =>{
      this.industryType =  JSON.parse(JSON.stringify(data)).industry;
    });


    this.getAdminClientUserData();
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('user_id', this.userId);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        this.service.getData(this.imageUploadUrl + "/" + this.userId).then(response => {
          if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
            this._imgUrl = JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
            this.fileName = '';
            this.service.showSuccess('Saved successfully');
          }
        });
      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };
    this.companyUploader.onBuildItemForm = (item, form) =>{
      form.append('token', localStorage.getItem('token'));
      form.append('user_id', this.userId);
    }
    this.companyUploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.companyUploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        if (this.userId !== undefined) {
          this.service.getData( this.imageUploadUrl + "/logo/" + this.userId).then(response => {
            if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
              this._companyLogo =  JSON.parse(JSON.stringify(response)).data.body[0].company_logo;
              this.companyFileName = '';
              this.service.showSuccess('Saved successfully');
            }
          });
        }
      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };
    this.showProfileImage();
  }


  showProfileImage() {
    this.service.getData(this.imageUploadUrl + "/" + this.userId).then(response => {
      if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
        this._imgUrl = JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
      }
    });
    this.service.getData(this.imageUploadUrl+"/logo" + "/" + this.userId).then(response => {
      if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
        this._companyLogo = JSON.parse(JSON.stringify(response)).data.body[0].company_logo;

      }
    });
  }
  // get formArr() {
  //   return this.invoiceForm.get('itemRows') as FormArray;
  // }

  // initItemRows() {
  //   return this.formBuilder.group({
  //     associate_site: ['']
  //   });
  // }

  // addNewRow(idx) {
  //   this.formArr.push(this.initItemRows());
  // }

  // deleteRow(index: number) {
  //   this.formArr.removeAt(index);
  // }

  getUserLicence() {
    this.service.getData(this.updateLicenceUrl + "/client/" + this.userId).then(async (res) => {
        if (JSON.parse(JSON.stringify(res)).length !== 0) {
          this.licenceTypeArray = JSON.parse(JSON.stringify(res));
        } else {}
      })
  }
  //get product check api

  getCheckedProduct(){
    this.service.getClientProductByID(this.getClientProductsUrl+ "/" +  Math.floor(Math.random() * 90 + 10) + this.userId + Math.floor(Math.random() * 9000 + 1000)).then((res) => {

      const parsedRes = JSON.parse(JSON.stringify(res));
      if (parsedRes.data.status === 'success') {
        const checkedIds = parsedRes.data.body.body.map((element) => element.product_type_id);
        this.productBoxList = this.productBoxListData.map((item) => {
          const isChecked = checkedIds.includes(item.id);
          return {
            ...item,
            checked: isChecked
          };
        });
         console.log(this.productBoxList,'productboxlist')
      } else {
          this.service.showError('Something went wrong.');
      }

    });
  }

  //get product list
  getProductList(){
    this.service.getProductType(this.productListingUrl).then((res) => {
      let response = JSON.parse(JSON.stringify(res)).data;
      console.log(response,'response')
      if (response.status === 'success') {
        this.productBoxListData = response.body.body;
        console.log(this.productBoxListData,'productbox')
        this.getCheckedProduct();
      } else {
        this.service.showError('Something went wrong.');
      }

    });
  }

  getAdminClientUserData() {
    this.getUserLicence();
    this.getProductList();
    this.updateDataReq = true;
    this.changeService.loader(true);
    this.service.getData(this.editUserUrl + "/" +
      Math.floor(Math.random() * 90 + 10) + this.userId + Math.floor(Math.random() * 9000 + 1000) ).then(response => {
      this.changeService.loader(false);
      const resp = JSON.parse(JSON.stringify(response)).data.body[0];
      if (resp.profile_image != null) {
        this._imgUrl = resp.profile_image;
      }
      this._imageId = resp.image_id;
      this._userRole = resp.role;
      let cmpny_name = new FormControl(resp.company_name);
      if (this._userRole === 'CLIENT') {
        cmpny_name = new FormControl(resp.company_name, [Validators.required, this.noWhitespaceValidator]);
      }
      // if(resp.country=='Canada' || resp.country=='United States'){
      //     resp.phone_no=resp.phone_no.slice(2);
      //   }else if(resp.country=='India'){
      //     resp.phone_no = resp.phone_no.slice(3);
      // }
      this.onChange(resp.country);
      if (JSON.parse(JSON.stringify(response)).data.status === 'success') {
        if (resp.manager_id !== "") {
          this.service.getData(this.editUserUrl + "/" + Math.floor(Math.random() * 90 + 10) + this.userId + Math.floor(Math.random() * 9000 + 1000) ).then(forManresponse => {
            if (JSON.parse(JSON.stringify(forManresponse)).data.status === 'success') {
              this.uForm = this.formBuilder.group({
                company_name: new FormControl(resp.company_name, [Validators.required, this.noWhitespaceValidator]),
                full_name: new FormControl(resp.full_name, [Validators.required, this.noWhitespaceValidator]),
                email: new FormControl(resp.email, ValidationService.emailValidator),
                industry_type: new FormControl(resp.industry_type, [Validators.required, this.noWhitespaceValidator]),
                password: new FormControl(''),
                phone_number: new FormControl(resp.phone_no, [ Validators.required]),
                address_line1: new FormControl(resp.address_1, [Validators.required, this.noWhitespaceValidator]),
                address_line2: new FormControl(resp.address_2),
                country_name_: new FormControl(resp.country, [Validators.required, this.noWhitespaceValidator]),
                state_name: new FormControl(resp.state, [Validators.required]),
                city_name: new FormControl(resp.city, [Validators.required, this.noWhitespaceValidator]),
                timezone: new FormControl(resp.timezone, [Validators.required, this.noWhitespaceValidator]),
                postcode: new FormControl(resp.postal_code, [Validators.required, this.noWhitespaceValidator]),
                number_of_license: new FormControl({ value: '', disabled: true }),
                account_manager: new FormControl({ value: JSON.parse(JSON.stringify(forManresponse)).data.body[0] === undefined ? "" : JSON.parse(JSON.stringify(forManresponse)).data.body[0].full_name, disabled: true }),
              });
            } else {
              this.service.showError('Something went wrong.');
            }
          });
        } else {
          console.log(resp.phone_no)
          this.uForm = this.formBuilder.group({
            company_name: new FormControl(resp.company_name, [Validators.required, this.noWhitespaceValidator]),
            full_name: new FormControl(resp.full_name, [Validators.required, this.noWhitespaceValidator]),
            email: new FormControl(resp.email, ValidationService.emailValidator),
            password: new FormControl(''),
            industry_type: new FormControl(resp.industry_type, [Validators.required, this.noWhitespaceValidator]),
            phone_number: new FormControl(resp.phone_no, [ Validators.required]),
            address_line1: new FormControl(resp.address_1, [Validators.required, this.noWhitespaceValidator]),
            address_line2: new FormControl(resp.address_2),
            country_name_: new FormControl(resp.country, [Validators.required, this.noWhitespaceValidator]),
            state_name: new FormControl(resp.state,[Validators.required]),
            city_name: new FormControl(resp.city, [Validators.required, this.noWhitespaceValidator]),
            timezone: new FormControl(resp.timezone, [Validators.required, this.noWhitespaceValidator]),
            postcode: new FormControl(resp.postal_code, [Validators.required, this.noWhitespaceValidator]),
            number_of_license: new FormControl({ value: "", disabled: true }),
            account_manager: new FormControl({ value: "", disabled: true }),
          });
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }


  upload(files: any, type) {
    if(type == 'clientPicture'){
      if (files[0].name !== undefined && files[0].name === '') {
        this.fileName = '';
      } else {
        this.showCancelBtn = true;
        this.fileName = files[0].name;
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress['progress'];
        };
      }
    }else{
      if (files[0].name !== undefined && files[0].name === '') {
        this.companyFileName = '';
      }else{
        this.fileName = files[0].name;
        this.companyUploader.uploadAll();
        this.companyUploader.onProgressItem = (progress: any) => {
          this.percentDone = progress['progress'];
        };
      }
    }
  }



  onChange(deviceValue) {
    let pullIndex;
    this.selectedCountry = deviceValue;
    if (deviceValue === 'Canada') {
      pullIndex = 1;
      this.maxLength = 6;
    } else if (deviceValue === 'United States') {
      pullIndex = 0;
      this.maxLength = 5;
    } else {
      pullIndex = 2;
      this.maxLength = 6;
    }
    this.service.load().then(data => {
      this.states = JSON.parse(JSON.stringify(data)).countries[pullIndex].states;
    });
  }
  private subscription: Subscription = new Subscription();

  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(this.http.put(signedRequest, files[0], { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.showCancelBtn = false;
          this.fileName = '';
          this.uploadSuccess = true;
          this._imgUrl = imageurl;
        }
      }));
  }
  cancelClick() {
    this.subscription.unsubscribe();
    this.fileName = '';
    this.showCancelBtn = false;
  }

  updateUserInfo() {
    let _imgId = null;
    if (this.uploadSuccess) {
      _imgId = this.id;
    }
    else if (this._imageId != null) {
      _imgId = this._imageId;
    }
    let reqObj = {
      company_name: this.uForm.value.company_name,
      full_name: this.uForm.value.full_name,
      phone_no: this.uForm.value.phone_number.e164Number,
      address_1: this.uForm.value.address_line1,
      address_2: this.uForm.value.address_line2,
      industry_type: this.uForm.value.industry_type,
      country: this.uForm.value.country_name_,
      state: this.uForm.value.state_name,
      city: this.uForm.value.city_name,
      postal_code: this.uForm.value.postcode,
      timezone: this.uForm.value.timezone,
      email: this.uForm.value.email,
      role: this._userRole === "ADMIN" ? "ADMIN" : this._userRole,
      edited_by:'CLIENT'
    };
      // localStorage.setItem
      localStorage.setItem('clientTimeZone', this.uForm.value.timezone);

    if (_imgId != null) {
      reqObj['image_id'] = _imgId;
    }
    // if(reqObj.country=='Canada' || reqObj.country=='United States'){
    //   reqObj.phone_no= '+1' + reqObj.phone_no;
    // }else if(reqObj.country=='India'){
    //   reqObj.phone_no= '+91' + reqObj.phone_no;
    // }
    const body = reqObj;
    this.changeService.loader(true);
    this.service.putData(this.editUserUrl + "/" + Math.floor(Math.random() * 90 + 10) + this.userId + Math.floor(Math.random() * 9000 + 1000) , body).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
        const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
        this.service.showError(msgErr);
      } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        //localStorage.setItem('clientTimeZone', JSON.parse(JSON.stringify(res)).data.body.timezone);
        this.service.showSuccess('User updated successfully');
        switch (localStorage.getItem('role')) {
          case 'ADMIN':
            // this.changeUserDashboard.login('Log In');
            this.router.navigate(['/admin-dashboard']);
            break;
          case 'CLIENT':
            // this.changeUserDashboard.login('Log In');
            this.router.navigate(['/device-reports']);
            break;
          case 'USER':
            // this.changeUserDashboard.login('Log In');
            this.router.navigate(['/device-reports']);
            break;
          case 'ACCOUNT_MANAGER':
            // this.changeUserDashboard.login('Log In');
            this.router.navigate(['/manager-client-list']);
            break;
          case 'OEM':
            this.router.navigate(['/OEM-Client']);
            break;
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  loadData(value) {
    localStorage.setItem('clientTimeZOne', value);
  }

  onCountryChange(num){
    Object.keys(this.uForm.controls).forEach(key => {
            const control = this.uForm.get(key);
            if (control && control.invalid) {
              console.warn(`Control "${key}" is invalid:`, control.errors);
            }
          });
  }
  removeUserImage(val){
    if(val == 'clientPicture'){
      this.service.getData(this.imageUploadUrl + "/remove/" + this.userId).then(response => {
        this._imgUrl = "./assets/img-new/default_user.png";
        this.service.showSuccess('Removed successfully.');
      });
    }else{
      this.service.getData(this.imageUploadUrl + "/logo" + "/remove/" + this.userId).then(response =>{
        this._companyLogo= "./assets/img-new/default_user.png";
        this.service.showSuccess("Removed successfully.");
      })
  }
  }


}
